<template>
    <div class="row">
        <div class="col-md-5" style="border-right: 1px solid #e0e0e0; height: 60vh; overflow: scroll;">
           <a-spin :spinning="loading">
            <div style="margin: 20px;">
                <div class="row">
                  
                  <h3 class="col-md-6">Locations</h3>

                  <div class="col-md-6">
                    <a-popconfirm v-if="selectedNode != null && selectedNode.is_lock == 0" title='Are you sure you want to delete this node?' class="btn btn-sm btn-danger float-right ml-2"  @confirm="() => deleteNode()">
                         <span class="fa fa-minus" /> Delete 
                    </a-popconfirm>
                    <button v-if="selectedNode != null && selectedNode.is_lock == 0" type="button" class="btn btn-sm btn-primary float-right" @click="addNode"> <span class="fa fa-plus" /> Add </button> 
                    <button v-if="selectedNode == null" type="button" class="btn btn-sm btn-primary float-right" @click="addNode"> <span class="fa fa-plus" /> Add </button> 
                  </div>

                  <small class="col-md-12 heading-small text-muted"><span class="fa fa-info-circle text-blue"/> Click on a specific location for more details.</small>
                </div>
                <!-- <hr class="my-3" /> -->
                <br />

                <a-tree showLine draggable :defaultExpandedKeys="expandedKeys" :defaultExpandAll="defaultExpandAll" class="draggable-tree"
                  @expand="onExpand" @select="onSelect" @dragenter="onDragEnter" @drop="onDrop"
                  :treeData="gData">
                    <template slot="title" slot-scope="{title}">
                      <span v-if="title.indexOf(searchValue) > -1">
                        {{title.substr(0, title.indexOf(searchValue))}}
                        <span style="color: #f50">{{searchValue}}</span>
                        {{title.substr(title.indexOf(searchValue) + searchValue.length)}}
                      </span>
                      <span v-else>{{title}} </span>
                    </template>
                </a-tree>
            </div>
            <!-- <div style="position: absolute; bottom: 0px; right: 0px; width: -webkit-fill-available; background-color: #f2f2f2 ; padding: 10px;"> -->
                
            <!-- </div> -->
           </a-spin>
        </div>
        <div class="col-md-7">
            <div v-if="selectedNode != null && addMode == false">
                <div style="margin: 20px;">
                  <b-tabs content-class="mt-3">
                      <b-tab title="Details">
                        <!-- {{selectedNode}} -->
                        <!-- {{selectedNode["title"]}} -->
                        <base-input label="Location Path" v-model="selectedNode['path']" disabled />
                        <base-input :disabled="selectedNode.is_lock == 1" label="Location Name" v-model="selectedNode['title']" />
                        <base-input :disabled="selectedNode.is_lock == 1" label="Code" v-model="selectedNode['code']" />
                      </b-tab>
                      <b-tab title="History">
                          <b><label>Created By: </label></b>
                          {{selectedNode['created_by'] || "System" }} | {{selectedNode['created_at'] | dateFilter}} 
                          <br>
                          <b><label>Updated By:</label></b>
                          {{selectedNode['updated_by'] || "System" }} | {{selectedNode['updated_at']| dateFilter}} 
                      </b-tab>
                  </b-tabs>
                  
                </div>
                <div v-if="selectedNode != null" style="position: absolute; bottom: 0px; right: 0px; width: 100%; background-color: #f2f2f2 ; padding: 10px;">
                    <button :disabled="selectedNode.is_lock == 1" type="button" class="btn btn-sm btn-success float-right" @click="updateLocation"> <span class="fa fa-save" /> Save </button> 
                </div>
            </div>
            <div v-else-if="addMode == true">
               <div style="margin: 20px;">
                Add Node <hr class="my-3" />
                <base-input label="Location Name" v-model="createNode.name" />
                <base-input label="Code" v-model="createNode.code" />
                <hr />
                <small v-if="selectedNode != null">Path: {{selectedNode['path']}}{{createNode.name}}</small>
                <small v-else>Path: {{createNode.name}}/</small>
               </div>
               <div style="position: absolute; bottom: 0px; right: 0px; width: 100%; background-color: #f2f2f2 ; padding: 10px;">
                    <button type="button" class="btn btn-sm btn-success float-right" @click="createLocation"> <span class="fa fa-save" /> Save </button> 
                </div>
            </div>
            <div v-else style="margin: 20px;">
                <a-empty />
            </div>
        </div>
    </div>

</template>

<script>

import HTTPRequest from '../../controllers/httpRequest.js';

let gData = []
const dataList = []
const generateList = (data) => {
  for (let i = 0; i < data.length; i++) {
    const node = data[i]
    const key = node.key
    dataList.push({ key, title: node.title })
    if (node.children) {
      generateList(node.children, node.key)
    }
  }
}

const getParentKey = (key, tree) => {
  let parentKey
  for (let i = 0; i < tree.length; i++) {
    const node = tree[i]
    if (node.children) {
      if (node.children.some(item => item.key === key)) {
        parentKey = node.key
      } else if (getParentKey(key, node.children)) {
        parentKey = getParentKey(key, node.children)
      }
    }
  }
  return parentKey
}

let node_ret = null
const getNode = function (key, tree){
  for (let i = 0; i < tree.length; i++) {
    const node = tree[i]
    if(node.key == key){
       node_ret = node 
    } else {
        if(node.children.length > 0){
            getNode(key, node.children)
        }
    }
  }
  return node_ret;
}

import { mapState, mapActions } from 'vuex'
import moment from 'moment'

export default {
    computed: {
       ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters']),
        // ...mapState(['endPoint', 'currentProfile', 'parameters', 'serverType'])
    },
    mounted: async function(){  
        this.loading = true
        this.gData = await HTTPRequest.getRequest(this.endPoint + '/locations/tree_view', null)  
        this.loading = false 
        this.defaultExpanded = this.gData[0].key
        this.expandedKeys.push(this.defaultExpanded)
        gData = this.gData
        generateList(gData)
    },
    data () {
        return {
            defaultExpanded: 1,
            expandedKeys: [],
            defaultExpandAll: false,
            gData ,
            selectedNode: null,
            createNode: {},
            addMode: false,
            loading: false,
        }
    },
    filters: {
        dateFilter: function (timestamp) {
            return moment(timestamp).format('L LTS')
        }
    },
    methods: {
        async onSelect(info){
            var selectedNode = getNode(info[0], gData)
            this.selectedNode = selectedNode
        },
        onExpand(expandedKeys) {
          this.selectedNode = null
        //   this.clearData()
          this.expandedKeys = expandedKeys
        //   this.autoExpandParent = false
        },
        addNode(){
            this.addMode = true
        },
        async createLocation(){
            var locationPayload = {}
            if(this.selectedNode == null)
                locationPayload = { location: { name: this.createNode.name, code: this.createNode.code}}
            else
                locationPayload = { location: { name: this.createNode.name, code: this.createNode.code, parent_id: this.selectedNode["key"]}}
            var createNode = await HTTPRequest.postRequest(this.endPoint + '/locations', null, locationPayload)   
            this.addMode = false
            this.gData = await HTTPRequest.getRequest(this.endPoint + '/locations/tree_view', null)   
            if(this.selectedNode != null)
                this.expandedKeys.push(this.selectedNode["key"])
            gData = this.gData
            this.createNode = {}
        },
        async updateLocation(){
            var locationPayload = { location: { name: this.selectedNode["title"], code: this.selectedNode["code"]}}
            var updateNote = await HTTPRequest.putRequest(this.endPoint + 'locations/' + this.selectedNode["key"], null, locationPayload)   
            this.gData = await HTTPRequest.getRequest(this.endPoint + '/locations/tree_view', null)   
            if(this.selectedNode != null)
                this.expandedKeys.push(this.selectedNode["key"])
            gData = this.gData
            this.selectedNode = null
        },
        async deleteNode(){
            var locationPayload = { location: { status: 'D'}}
            var updateNote = await HTTPRequest.putRequest(this.endPoint + 'locations/' + this.selectedNode["key"], null, locationPayload)   
            this.gData = await HTTPRequest.getRequest(this.endPoint + '/locations/tree_view', null)   
            if(this.selectedNode != null)
                this.expandedKeys.push(this.selectedNode["key"])
            gData = this.gData
            this.selectedNode = null
        },
        onDragEnter (info) {
        },
        async onDrop (info) {
            // eslint-disable-next-line
            var for_update = info.dragNode.$options.propsData.eventKey
            // console.log(for_update)
            var new_parent = info.node.$options.propsData.eventKey
            var locationPayload = {location: {parent_id: new_parent} }
            var updateNote = await HTTPRequest.putRequest(this.endPoint + '/locations/' + for_update + '?mode=drag' , null, locationPayload)   
            this.gData = await HTTPRequest.getRequest(this.endPoint + '/locations/tree_view', null)   
            if(this.selectedNode != null)
                this.expandedKeys.push(this.selectedNode["key"])
            gData = this.gData
            this.selectedNode = null
        },
    }
}
</script>

<style>
</style>
